import { InvoiceCreate } from "./index";
import { CreateInvoiceProvider } from "./context/CreateInvoiceProvider";
import type { JobEventForInvoice } from "../../jobs/jobs-details/events/board/context";
import type { InvoiceVisitGroupSelection } from "./types/invoiceVisitGroups";

export type { InvoiceVisitGroupSelection } from "./types/invoiceVisitGroups";

interface Props {
  jobUid: number;
  jobEvents: JobEventForInvoice[];
  clientUid: string;
  scopeOfWorkUid: string;
  eventSchedulerUid: string;
  invoiceModal?: string;
  /** When set, billed visits card groups rows by job (client multi-job selection). */
  visitGroups?: InvoiceVisitGroupSelection[];
}

export function InvoiceCreateView({ clientUid, eventSchedulerUid, jobEvents, jobUid, scopeOfWorkUid, invoiceModal, visitGroups }: Props) {
  const primaryUid = jobEvents[0]?.uid ?? "draft";
  return (
    <CreateInvoiceProvider>
      <InvoiceCreate
        jobEvents={jobEvents}
        clientUid={clientUid}
        eventSchedulerUid={eventSchedulerUid}
        jobUid={jobUid}
        scopeOfWorkUid={scopeOfWorkUid}
        invoiceModal={invoiceModal ?? `Dashboard-InvoiceCreate-${primaryUid}`}
        visitGroups={visitGroups}
      />
    </CreateInvoiceProvider>
  );
}

// Exports for generic / usage invoice creation flow
export { InvoiceCreateAdapter } from "./InvoiceCreateAdapter";
export type { GenericInvoiceInput, GenericInvoiceClient, GenericInvoiceLineItem } from "./types/genericInvoice";

export type { RawPhoneBillingRecord } from "./utils/parsePhoneBilling";
